import type { PipelineFilterDefinition } from '@/pages/pipelines/common/types';

import { INVESTMENT_PIPELINE_FILTER_KEYS } from '../config';
import type { InvestmentPipelineUrlFilters } from '../types';

const INVESTMENT_TYPE_OPTIONS = [
  { value: 'NewInvestor', label: 'New Investor' },
  { value: 'ExistingInvestor', label: 'Existing Investor' },
  { value: 'DualNewAndExisting', label: 'New + Existing Investor' },
  { value: 'None', label: 'None' },
];

const INVESTMENT_TIMER_OPTIONS = [
  { value: 'Active', label: 'Active timers' },
  { value: 'Green', label: 'Green' },
  { value: 'Yellow', label: 'Yellow' },
  { value: 'Red', label: 'Red' },
  { value: 'None', label: 'No timer' },
];

const NO_INTRODUCER_OPTION = {
  value: 'None',
  label: 'None',
};

export const getInvestmentPipelineFilterDefinitions = (
  definitions: PipelineFilterDefinition[],
): PipelineFilterDefinition<InvestmentPipelineUrlFilters>[] =>
  definitions
    .filter((definition): definition is PipelineFilterDefinition<InvestmentPipelineUrlFilters> =>
      INVESTMENT_PIPELINE_FILTER_KEYS.has(definition.key as keyof InvestmentPipelineUrlFilters),
    )
    .map((definition) => {
      if (definition.key === 'introducerUserIds') {
        return {
          ...definition,
          includeOption: {
            option: NO_INTRODUCER_OPTION,
            flagKey: 'includeNoIntroducer',
          },
        };
      }

      if (definition.key === 'introductionTypes' && !definition.options?.length) {
        return { ...definition, options: INVESTMENT_TYPE_OPTIONS, controlSize: 'small' };
      }

      if (definition.key === 'timerStatuses' && !definition.options?.length) {
        return { ...definition, options: INVESTMENT_TIMER_OPTIONS, controlSize: 'small' };
      }

      if (definition.key === 'introductionTypes' || definition.key === 'timerStatuses') {
        return { ...definition, controlSize: 'small' };
      }

      return definition;
    });

export const sanitizeInvestmentPipelineFilters = (
  filters: Partial<InvestmentPipelineUrlFilters>,
): InvestmentPipelineUrlFilters => ({
  introducerUserIds: filters.introducerUserIds ?? [],
  includeNoIntroducer: filters.includeNoIntroducer,
  investorUserIds: filters.investorUserIds ?? [],
  fundIds: filters.fundIds ?? [],
  introductionTypes: filters.introductionTypes ?? [],
  timerStatuses: filters.timerStatuses ?? [],
  stages: filters.stages ?? [],
  activeOnly: filters.activeOnly,
  sort: filters.sort,
  card: filters.card,
});
